import {
  getTotalReorderDiscount,
  usePricing,
} from '@customink/project-service-react-components';

import { LineItem } from './LineItem';

import { PgmntColorFeedbackSuccessAccessible } from '@/utils/designTokens';
export function ReorderLineItem() {
  const { data: pricingData, isLoading } = usePricing();
  const reorderDiscount = getTotalReorderDiscount(
    Object.values(pricingData.grouped),
  );

  if (reorderDiscount.gte(0)) return null;

  const reorderDiscountNumber = reorderDiscount.times(-1).toFixed(2);
  const reorderDiscountValue = `-$${reorderDiscountNumber}`;

  return (
    <LineItem
      isLoading={isLoading}
      name="Reorder Discount"
      sxValue={{ color: PgmntColorFeedbackSuccessAccessible }}
      tagPrefix="reorder"
      value={reorderDiscountValue}
    />
  );
}
